import {
  Survey,
  SurveyPayload,
  ExtendedSurvey,
} from './surveyTypes';
import { Enrollment } from './enrollmentTypes';
import { Submission } from './submissionTypes';
import { GroundTruth } from './groundTruthTypes';

/** Model Types */
export interface Trial {
  id: number;
  name: string;
  code: string;
  startDate: string;
  endDate: string;
  registrationStartDate: string;
  registrationEndDate: string;
  samples: string;
  participants: number;
  enrollments: number;
  deliveries: number;
  manual: string;
  certificateTemplates: CertificateTemplateType;
  costCenter: string;
  priceInEUR: number;
  leadOnCertificate: string;
  nameOnCertificate: string;
  hideIndividualScores: boolean;
  deactivate: boolean;
  leadInstitute: number | null;
  parentTrialId?: number;
  trialCategory?: number;
  reviewCategoryId?: number;
  availableBoth?: boolean;
  isDRT: boolean;
  international?: boolean;
  terms?: string;
  discardShippingFee?: boolean;
  discardAdminFee?: boolean
  version?: number;
  isAccredited?: boolean;
  manualUploadCert?: boolean;
  canExportMammaReview?: boolean;
}

export interface ThirdPartyTrial {
  id: number;
  createdAt: string;
  extTrialId: number;
  provider: string;
  extensions: unknown;
  trialid: number;
}

export type CertificateTemplateType = {
  success?: string;
  fail?: string;
}

type TrialWithSurvey = Trial & {
  survey?: Survey & ExtendedSurvey & { groundTruth?: GroundTruth[] };
};
type EnrollmentWithSubmission = Enrollment & {
  submission?: Submission;
}
export type StateTrial = (TrialWithSurvey & { enrollment?: EnrollmentWithSubmission });

export interface TrialState {
  isFetching: boolean;
  trial?: StateTrial;
  surveyPayloadCopy: SurveyPayload | null;
  surveyPayloadRestored: boolean;
  trialList: Trial[];
  yearFilter: string;
}

/** Constants for Trial actions and reducers */

export const FETCH_TRIAL_START = 'FETCH_TRIAL_START';
export const FETCH_TRIAL_SUCCESS = 'FETCH_TRIAL_SUCCESS';
export const FETCH_TRIAL_FAIL = 'FETCH_TRIAL_FAIL';
export const UPDATE_TRIALS_SURVEY = 'UPDATE_TRIALS_SURVEY';
export const RESTORE_SURVEY_PAYLOAD = 'RESTORE_SURVEY_PAYLOAD';
export const SET_SURVEY_PAYLOAD_RESTORED = 'SET_SURVEY_PAYLOAD_RESTORED';
export const SET_YEAR_FILTER = 'SET_YEAR_FILTER';
export const SET_TRIAL_LIST = 'SET_TRIAL_LIST';

/** Acion types */

interface RequestTrialAction {
  type: typeof FETCH_TRIAL_START;
}

interface RequestTrialSuccessAction {
  type: typeof FETCH_TRIAL_SUCCESS;
  payload: Trial & {survey?: Survey};
}

interface RequestTrialFailAction {
  type: typeof FETCH_TRIAL_FAIL;
}

interface UpdateTrialsSurveyAction {
  type: typeof UPDATE_TRIALS_SURVEY;
  payload: Survey | ExtendedSurvey;
}

interface RestoreSurveyPayloadAction {
  type: typeof RESTORE_SURVEY_PAYLOAD;
}

interface SetSurveyPayloadRestoredAction {
  type: typeof SET_SURVEY_PAYLOAD_RESTORED;
  payload: boolean;
}

interface SetYearFilterAction {
  type: typeof SET_YEAR_FILTER;
  payload: string;
}

interface SetTrialListAction {
  type: typeof SET_TRIAL_LIST;
  payload: Trial[];
}

export type TrialActionTypes =
  RequestTrialAction |
  RequestTrialSuccessAction |
  RequestTrialFailAction |
  UpdateTrialsSurveyAction |
  RestoreSurveyPayloadAction |
  SetSurveyPayloadRestoredAction |
  SetYearFilterAction |
  SetTrialListAction;
